(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("agCharts"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["agCharts", ], factory);
	else if(typeof exports === 'object')
		exports["ag-charts-vue"] = factory(require("agCharts"), require("vue"));
	else
		root["ag-charts-vue"] = factory(root["agCharts"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4d8b__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 